import { REGION_AU, REGION_US } from 'global/constants';
import { Dropdown, DropdownIndicator } from 'approot/shared/dropdown/dropdown';
import { REGION_OPTIONS, Regions } from './region.constants';
import { useRegionData } from './region.apollo';
import * as Styled from './region-dropdown.style';

import au from './au.png';
import us from './us.png';

const flags = {
  [REGION_AU]: au,
  [REGION_US]: us,
};

export const RegionDropdown = ({
  noBorder,
  redirectTo,
}: {
  noBorder?: boolean;
  redirectTo?: string;
}) => {
  const { region } = useRegionData();
  return (
    <Dropdown
      aria-label="Change country"
      data-selector="change-country"
      selectedValue={region}
      options={REGION_OPTIONS}
      dropdownButtonContents={
        <Styled.RegionDropdownButton $noBorder={noBorder}>
          <RegionLabel region={region} />
          <DropdownIndicator />
        </Styled.RegionDropdownButton>
      }
      onSelect={option => {
        if (option.value !== region) {
          window.location.replace(
            `${window.location.origin}/${option.value}${redirectTo || ''}`
          );
        }
      }}
    />
  );
};

export const RegionLabel = ({ region }: { region: Regions }) => (
  <>
    <Styled.RegionDropdownFlag>
      <img src={flags[region]} alt="" />
    </Styled.RegionDropdownFlag>
    <Styled.RegionDropdownText>
      {REGION_OPTIONS.find(r => r.value === region)?.label}
    </Styled.RegionDropdownText>
  </>
);
